import React from 'react'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'

export default function Spiner() {

    return (
        <Box
            role="status"
            aria-live="polite"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 180,
                py: 6,
                color: 'text.secondary',
            }}
        >
            <CircularProgress size={32} thickness={4} />
            <Typography variant="body2" sx={{ mt: 1.5, fontWeight: 600 }}>
                데이터를 불러오는 중입니다.
            </Typography>
        </Box>
    )
}
